<div *ngIf="!isCustomUiChange">
    <h5 mat-dialog-title style="padding:0.2vw; color:black; margin:0 !important">Create ProgramSponsor</h5>
    <mat-divider></mat-divider>
    <div mat-dialog-content style="height: 80vh; width: 100vh;">
        <mat-card class="user-card" style="width: 95%;">
            <mat-card-content style="margin-bottom: 0px;height: 55vh;">
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>ProgramSponsor ID</mat-label>
                    <input matInput placeholder="ProgramSponsor ID" [(ngModel)]="programSponsorId"
                        (focusin)="clearMessage()" maxlength="20">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>ProgramSponsor Name</mat-label>
                    <input matInput placeholder="ProgramSponsor Name" [(ngModel)]="programSponsorName"
                        (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <br>
                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>SalesForce User Name</mat-label>
                    <input matInput placeholder="SF Username" [(ngModel)]="salesforceUsername"
                        (focusin)="clearMessage()" maxlength="255">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>SalesForce Password</mat-label>
                    <input matInput type="password" placeholder="SF Password" [(ngModel)]="salesforcePassword"
                        (focusin)="clearMessage()" maxlength="255">
                </mat-form-field>
                <br>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Compass Email</mat-label>
                    <input matInput type="email" placeholder="Email" [(ngModel)]="compassEmail"
                        (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Compass Password</mat-label>
                    <input matInput type="password" placeholder="Password" [(ngModel)]="compassPassword"
                        (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <br>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Compass Uri</mat-label>
                    <input matInput type="url" placeholder="Compass Uri" [(ngModel)]="compassUri"
                        (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>Source</mat-label>
                    <mat-select [(ngModel)]="selectedSource">
                        <mat-option *ngFor="let source of sources" [value]="source.SourceId" style="font-size: 11px;">
                            {{source.SourceName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br>
                <mat-slide-toggle class="formfield-half" [(ngModel)]="programSponsorActive">Active</mat-slide-toggle>
                <label class="formfield-half" style="color: red; font-size: 0.9vw">{{errorMessage}}</label>

            </mat-card-content>
            <br>
            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="savePSponsor();">SAVE</button>
                <button mat-raised-button color="primary" (click)="cancelPSponsor();">CANCEL</button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>


<!-- refactor for new UI design FEMD and DOM1 -->
<div *ngIf="isCustomUiChange" class="ps-create-container">
    <mat-card class="ps-create-card">
        <mat-card-header class="ps-card-header">
            <mat-card-title class="ps-create-title"> Create Program Sponsor </mat-card-title>
            <button mat-icon-button class="ps-create-close" (click)="cancelPSponsor()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>

        <mat-divider></mat-divider>

        <mat-card-content class="ps-create-form">
            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>ProgramSponsor ID</mat-label>
                <input matInput [(ngModel)]="programSponsorId" maxlength="20" placeholder="ProgramSponsor ID"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>ProgramSponsor Name</mat-label>
                <input matInput [(ngModel)]="programSponsorName" maxlength="50" placeholder="ProgramSponsor Name"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>SalesForce User Name</mat-label>
                <input matInput [(ngModel)]="salesforceUsername" maxlength="255" placeholder="SF Username"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>SalesForce Password</mat-label>
                <input matInput type="password" [(ngModel)]="salesforcePassword" maxlength="255"
                    placeholder="SF Password" (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>Compass Email</mat-label>
                <input matInput type="email" [(ngModel)]="compassEmail" maxlength="50" placeholder="Email"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>Compass Password</mat-label>
                <input matInput type="password" [(ngModel)]="compassPassword" maxlength="50" placeholder="Password"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>Compass Uri</mat-label>
                <input matInput type="url" [(ngModel)]="compassUri" maxlength="50" placeholder="Compass Uri"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ps-field-half">
                <mat-label>Source</mat-label>
                <mat-select [(ngModel)]="selectedSource">
                    <mat-option *ngFor="let source of sources" [value]="source.SourceId">
                        {{ source.SourceName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="programSponsorActive">Active</mat-slide-toggle>
            <label class="ps-error-msg">{{ errorMessage }}</label>
        </mat-card-content>

        <mat-card-actions class="ps-create-actions">
            <button mat-raised-button color="primary" (click)="savePSponsor()">SAVE</button>
            <button mat-raised-button color="primary" (click)="cancelPSponsor()">CANCEL</button>
        </mat-card-actions>
    </mat-card>

</div>